import { LVG_ASSETS } from 'constants/games/lvg/lvgAssets'
import { usePriceFeed } from 'hooks/usePriceFeed'
import { useEffect, useRef } from 'react'
import { getPnL, getPnl2 } from 'utils/pnl'

export const useActivePnl = (order) => {
  const { asset, pnl, entryPrice, side, fillQuantity, leverage, fundingFee } = order
  const pnlRef = useRef()
  const priceSymbol = LVG_ASSETS.find(
    (assetInfo) => assetInfo.id === asset
  )?.id
  const { priceFeed } = usePriceFeed(priceSymbol)

  useEffect(() => {
    if (!priceFeed?.price) return
    pnlRef.current =
      pnl ??
    //getPnL(entryPrice, priceFeed?.price, side, fillQuantity, leverage, asset)
      // { asset, entryPrice, exitPrice, fillQuantity, side, leverage, fundingFee }
      getPnl2({ asset, entryPrice, exitPrice:priceFeed?.price, fillQuantity, side, leverage, fundingFee })
      // getPnl2(entryPrice, priceFeed?.price, side, fillQuantity, leverage, asset, fundingFee)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priceFeed?.price])

  return { activePnl: pnlRef.current }
}
